/**
 * @fileoverview A function that provides the events API.
 *
 * @example
 * const { result } = renderHook(() => useEventsAPI())
 */

import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from './utils/axiosBaseQuery'

/**
 * @function eventsApi
 * @description Provides the events API.
 * @returns {ReturnType<typeof createApi>} - The events API.
 */
export const eventsApi = createApi({
    reducerPath: 'eventsApi',
    baseQuery: axiosBaseQuery({ baseUrl: `/private/patientEvents` }),
    endpoints: (builder) => ({
        getParticipantEvents: builder.query<Novoic.API.ParticipantEvent[], string>({
            query: (participantId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('patients', participantId)
                return {
                    url: `?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),

        getParticipantEventsCount: builder.query<{ count: number }, string>({
            query: (participantId: string) => {
                const sp = new URLSearchParams(location.search)
                sp.set('patients', participantId)
                return {
                    url: `/count?${sp.toString()}`,
                    method: 'GET',
                }
            },
        }),
    }),
})

export const { useGetParticipantEventsCountQuery, useGetParticipantEventsQuery } = eventsApi
